import { makeActionCreator } from '../../config/store/utils'
import { getRegionalNationalLevels, getRegionalProvidersSize } from '../../services/regions'

const COLORS_DICTIONARY = {
  Grande: 'dodgerBlue',
  Mediana: 'purpleHeart',
  Micro: 'ruby',
  NoClasificado: 'teal',
  Pequeña: 'grape'
}

const SORTED_COLLECTION = ['Grande', 'Mediana', 'Pequeña', 'Micro', 'NoClasificado']

export const GET_REGIONAL_NATIONAL_LEVEL = 'GET_REGIONAL_NATIONAL_LEVEL'
export const GET_REGIONAL_NATIONAL_LEVEL_ERROR = 'GET_REGIONAL_NATIONAL_LEVEL_ERROR'
export const GET_REGIONAL_NATIONAL_LEVEL_SUCCESS = 'GET_REGIONAL_NATIONAL_LEVEL_SUCCESS'
export const onGetRegionalNationalLevel = makeActionCreator(GET_REGIONAL_NATIONAL_LEVEL)
export const onGetRegionalNationalLevelError = makeActionCreator(GET_REGIONAL_NATIONAL_LEVEL_ERROR, 'payload')
export const onGetRegionalNationalLevelSuccess = makeActionCreator(GET_REGIONAL_NATIONAL_LEVEL_SUCCESS, 'payload')
export const onGetRegionalNationalLevelThunk = payload => async dispatch => {
  dispatch(onGetRegionalNationalLevel())

  try {
    const { data } = await getRegionalNationalLevels({ year: payload.year })
    const enhancedData =
      data.payload.map(item => ({
        amount: item.amountRegionCLP,
        amountUSD: item.amountRegionUSD,
        colorName: item.idRegion === payload.regionId ? 'primary' : 'gray2',
        dataLabels: {
          className: item.idRegion === payload.regionId ? 'highlightLabel' : 'simpleLabel'
        },
        id: item.idRegion,
        name: item.region,
        orders: item.quantityRegionOC,
        percentage: item.percentage,
        y: item.amountRegionCLP,
        year: payload.year,
        z: item.idRegion === payload.regionId ? 100 : 70
      })) || []
    const csv = [
      ['Año', 'Región', 'Monto transado', 'Monto transado (USD)', 'Nº de órdenes de compra'],
      ...enhancedData.map(item => [item.year, item.name, item.amount, item.amountUSD, item.orders])
    ]
    const [item] = data.payload

    return dispatch(
      onGetRegionalNationalLevelSuccess({
        csv,
        data: enhancedData,
        totalAmount: item.amountStatusAnualCLP || 0,
        totalAmountUSD: item.amountStatusAnualUSD || 0
      })
    )
  } catch (error) {
    return dispatch(onGetRegionalNationalLevelError({ error }))
  }
}

export const GET_REGIONAL_PROVIDERS_SIZE = 'GET_REGIONAL_PROVIDERS_SIZE'
export const GET_REGIONAL_PROVIDERS_SIZE_ERROR = 'GET_REGIONAL_PROVIDERS_SIZE_ERROR'
export const GET_REGIONAL_PROVIDERS_SIZE_SUCCESS = 'GET_REGIONAL_PROVIDERS_SIZE_SUCCESS'
export const onGetRegionalProvidersSize = makeActionCreator(GET_REGIONAL_PROVIDERS_SIZE)
export const onGetRegionalProvidersSizeError = makeActionCreator(GET_REGIONAL_PROVIDERS_SIZE_ERROR, 'payload')
export const onGetRegionalProvidersSizeSuccess = makeActionCreator(GET_REGIONAL_PROVIDERS_SIZE_SUCCESS, 'payload')
export const onGetRegionalProvidersSizeThunk = payload => async dispatch => {
  dispatch(onGetRegionalProvidersSize())

  try {
    const { data } = await getRegionalProvidersSize({ regionId: payload.regionId, year: payload.year })
    const enhancedData =
      SORTED_COLLECTION.map(key => {
        const item = data.payload.find(datum => datum.name === key) || {}

        return {
          amount: item?.amountCLPAnual,
          amountUSD: item?.amountUSDAnual,
          colorName: COLORS_DICTIONARY[item?.name],
          detail: `${item?.quantityOC || 0} órdenes de compra`,
          name: item?.name === 'NoClasificado' ? 'No clasificado' : item?.name,
          orders: item?.quantityOC,
          percentage: item?.percentage,
          year: item?.year
        }
      }) || []
    const totalAmount = enhancedData.reduce((total, datum) => total + datum?.amount, 0)
    const totalAmountUSD = enhancedData.reduce((total, datum) => total + datum?.amountUSD, 0)
    const csv = [
      ['Año', 'Tamaño empresa proveedor', 'Monto transado', 'Monto transado (USD)', 'Nº de órdenes de compra'],
      ...enhancedData.map(item => [item.year, item.name, item.amount, item.amountUSD, item.orders])
    ]

    return dispatch(onGetRegionalProvidersSizeSuccess({ csv, totalAmount, totalAmountUSD, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetRegionalProvidersSizeError({ error }))
  }
}
